/** A problem with the numbers Brett entered, with a message fit to show him directly. */
export class CommissionInputError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CommissionInputError';
  }
}
